import api from 'lib/api';

export const GET_FORM = 'GET_FORM';

export const getForm = (id) => ({
	type: GET_FORM,
	payload: new Promise(resolve => {
		api.get(`forms/${id}`).then((response) => {
			resolve(response.data);
		});
	}),
});